import React from "react";
import {
    Box,
    Card,
    CardContent,
    Divider,
    Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
}));

const InvitationAccordianCard = (props) => {
    const classess = useStyles();
    const { item } = props;
    const InvitationInfo = item.actualData;

    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: "none" }} >
                <CardContent className={classess.cardContent}>

                    <Box sx={{
                        flexGrow: 1,
                    }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'left',
                                alignItems: 'left',
                                p: 1
                            }}>
                            <Typography
                                variant="h4"
                                fontSize={12}
                                fontWeight={500}
                                color="primary"
                                sx={{ width: "70px" }}
                            >
                                CC Email:
                            </Typography>
                            <Typography
                                variant="h4"
                                fontSize={14}
                                fontWeight={400}>
                                <span>{InvitationInfo.ccEmailID}</span>
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{
                        flexGrow: 1,
                    }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'left',
                                alignItems: 'left',
                                p: 1
                            }}>
                            <Typography
                                variant="h4"
                                fontSize={12}
                                fontWeight={500}
                                color="primary"
                                sx={{ width: "70px" }}
                            >
                                BCC Email:
                            </Typography>
                            <Typography
                                variant="h4"
                                fontSize={14}
                                fontWeight={400}>
                                <span>{InvitationInfo.bccEmailID}</span>
                            </Typography>
                        </Box>
                    </Box>
                    {InvitationInfo.modifiedByName !== "" ? <Box sx={{
                        flexGrow: 1,
                    }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'left',
                                alignItems: 'center',
                                p: 1
                            }}>
                            <Typography
                                variant="h4"
                                fontSize={12}
                                fontWeight={500}
                                color="primary"
                                sx={{ width: "70px" }}
                            >
                                Modified By:
                            </Typography>
                            <Typography
                                variant="h4"
                                fontSize={14}
                                fontWeight={400}>
                                <span>{InvitationInfo.modifiedByName}</span>
                            </Typography>
                        </Box>
                    </Box> : ""}

                </CardContent>
            </Card>
        </>
    )
}

export default InvitationAccordianCard;